import type { ArtifactKind } from '@inference.engine/widgets';
import { Badge } from '@monksflow/monks-ui';
import { ARTIFACT_KIND_PALETTE } from '../../lib/artifact-kind-palette';

interface Props {
  kind: ArtifactKind;
}

/**
 * The artifact's type badge — icon + palette label in the kind's colours.
 * Shared so the Library grid card and the picker's Type column render the
 * same thing and can't drift apart.
 */
export function ArtifactKindBadge(props: Props) {
  const palette = ARTIFACT_KIND_PALETTE[props.kind];
  const KindIcon = palette.icon;
  return (
    <Badge variant={palette.variant} roundness="full">
      <KindIcon className="size-3" />
      {palette.label}
    </Badge>
  );
}
